var React = require('react');

function DifficultyLevelBlackWhiteOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.707107 19.1273L19.1272 0.707126L37.5474 19.1273L19.1272 37.5474L0.707107 19.1273Z","fill":"black","stroke":"white"}));
}

DifficultyLevelBlackWhiteOutline.defaultProps = {"viewBox":"0 0 39 39","fill":"none"};

module.exports = DifficultyLevelBlackWhiteOutline;

DifficultyLevelBlackWhiteOutline.default = DifficultyLevelBlackWhiteOutline;
